import React, { createContext, useEffect, useState } from 'react';
import AuthService from '../ApiServices/AuthService';
import { alertErrorMessage } from '../CustomAlertModel';

export const ProfileContext = createContext();

export function ProfileProvider(props) {

  const [loginDetails, setLoginDetails] = useState({});
  const token = sessionStorage.getItem("token");
  const [userDetails, setUserDetails] = useState([]);
	const [wlletBalance, setWalletBalance] = useState('');

  useEffect(() => {
    if (token) {
      handleUserProfile();
      handleWalletBalance();
    }
  }, [token]);

  const handleUserProfile = async () => {
    const result = await AuthService.getDetails();
    if (result?.success) {
      setUserDetails(result?.data);
    } else {
      // alertErrorMessage(result?.message);
    }
  };

  const handleWalletBalance = async () => {
		const result = await AuthService.walletBalance();
			if (result?.success) {
				setWalletBalance(result?.data);
			} 
	};

  return (
    <ProfileContext.Provider value={{ setLoginDetails, loginDetails, userDetails, handleUserProfile,wlletBalance,handleWalletBalance }}>
      {props.children}
    </ProfileContext.Provider>
  );
}
